import { render, staticRenderFns } from "./ServiceCase.vue?vue&type=template&id=50cd72ca&scoped=true&"
import script from "./ServiceCase.vue?vue&type=script&lang=js&"
export * from "./ServiceCase.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCase.vue?vue&type=style&index=0&id=50cd72ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd72ca",
  null
  
)

export default component.exports